import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import BaseDrawer from "./BaseDrawer";

interface LiveInfoDrawerProps {
  open: boolean;
  handleClose: () => void;
}

const LiveInfoDrawer: React.FC<LiveInfoDrawerProps> = ({
  open,
  handleClose,
}) => {
  const [currentImage, setCurrentImage] = useState(0);
  const images = ["/images/250621/Porto1.png", "/images/250621/Porto2.png"];

  React.useEffect(() => {
    const container = document.getElementById("live-images-container");
    if (!container) return;

    const handleScroll = () => {
      const scrollLeft = container.scrollLeft;
      const newIndex = Math.round(scrollLeft / 300);
      setCurrentImage(newIndex);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [open]);

  return (
    <BaseDrawer
      open={open}
      handleClose={handleClose}
      height="80vh"
      background="#ffffff"
    >
      <Box sx={{ px: 0, pb: 4, height: "100%", flex: 1 }}>
        {/* ヘッダー */}
        <Box
          sx={{
            mb: 2,
            px: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h6"
            sx={{ color: "#53696d", fontWeight: "bold" }}
          >
            次回ライブのご案内
          </Typography>
        </Box>

        {/* 画像表示 */}
        <Box
          data-scrollable
          sx={{
            display: "flex",
            overflowX: "auto",
            scrollSnapType: "x mandatory",
            scrollBehavior: "smooth",
            width: 300,
            height: 300,
            mx: "auto",
            borderRadius: 2,
            backgroundColor: "#f5f5f5",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          id="live-images-container"
        >
          {images.map((image, index) => (
            <Box
              key={index}
              component="img"
              src={image}
              alt={`Portoライブ画像${index + 1}`}
              sx={{
                minWidth: "100%",
                height: "100%",
                objectFit: "contain",
                scrollSnapAlign: "start",
                scrollSnapStop: "always",
              }}
            />
          ))}
        </Box>

        {/* インジケーター */}
        <Box display="flex" justifyContent="center" mt={2}>
          {images.map((_, index) => (
            <Box
              key={index}
              onClick={() => {
                const container = document.getElementById(
                  "live-images-container"
                );
                if (container) {
                  container.scrollTo({
                    left: index * 300,
                    behavior: "smooth",
                  });
                  setCurrentImage(index);
                }
              }}
              sx={{
                width: 8,
                height: 8,
                mx: 0.5,
                borderRadius: "50%",
                backgroundColor: currentImage === index ? "#53696d" : "#b4bdbb",
                cursor: "pointer",
                transition: "all 0.3s",
                "&:hover": {
                  transform: "scale(1.5)",
                  backgroundColor: "#53696d",
                },
              }}
            />
          ))}
        </Box>

        <Typography
          variant="body1"
          align="center"
          sx={{ mt: 2, px: 2, color: "#2c3f42", fontWeight: "bold" }}
        >
          ご予約は直接お声がけください！
        </Typography>
      </Box>
    </BaseDrawer>
  );
};

export default LiveInfoDrawer;
